// src/api/query/useTempCollaboratorLogin.ts

import { useQuery } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import { QUERY_KEYS } from "./querykeys";
import {
  AxiosResponseAndError,
  ResponseType,
} from "../types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type TokensResponse = ResponseType<null>;

function useTempCollaboratorLogin(userId: string) {
  return useQuery<
    AxiosResponseAndError<TokensResponse>["response"],
    AxiosResponseAndError<TokensResponse>["error"]
  >({
    queryKey: [QUERY_KEYS.collaboratorVerificationToken, userId],
    queryFn: async () =>
      await ApiRequest.get(requestURLs.collaboratorVerificationToken + userId),
    enabled: false,
  });
}

export default useTempCollaboratorLogin;
